<template>
    <div class="version-download-control">
        <a href="#"
           class="hover-effect"
           @click.prevent="launchApp('IB2.IOT', 'AT')"
        >
            <img src="~images/btn-ios.png">
        </a>
        <a href="#"
           class="hover-effect"
           @click.prevent="launchApp('IB2.ADT', 'GT')"
        >
            <img src="~images/btn-android.png">
        </a>
        <a href="#"
           class="hover-effect"
           @click.prevent="launchApp('IB2.WIN', 'DW')"
        >
            <img src="~images/btn-windows.png">
        </a>

    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUnmounted, onUpdated, watchEffect, watch, computed,nextTick, inject}  from "vue";
    import {authenticate, handleSSO} from "@/modules/api/auth";
    import {changeLang} from "@/modules/i18n/i18n";
    import SimpleList from "@/views/lib/listing/SimpleList";
    import Links from "@/views/template/Links";
    import router from "@/router"
    import axios from "axios";
    import config from "@/config/config.json";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";

    export default {
        props:{
            paramSsoToken:String,
        },
        setup(props, context) {

            const data = reactive({})
            const i18n = inject('i18n');
            const launchApp = (client, platform) => {

                setTimeout(async()=>{
                    //if login from sso, use get license unit api to get access details
                    if (localStorage.isSSO  && localStorage.accessToken && isTouchDevice()) {

                        let licenseData = JSON.parse(localStorage.licensingUnit).data;
                        for (let item of licenseData[0]["links"]) {
                            if (item.platform === platform) {
                                let uri = item.uri.replace("ACCESS_TOKEN", props.paramSsoToken);
                                window.location = uri;
                            }
                        }
                        //otherwise, use the get app link
                    } else {

                        let response = await axios.get(process.env.VUE_APP_LINK_EBOOK_PLATFORM);

                        for (let item of response.data) {

                            if (item.client === client) {
                                //window.location.assign(item.download);

                                if (client !== "IB2.WIN") {
                                    window.location = item.download;
                                } else {
                                    window.location = item.link;
                                }

                            }

                        }

                    }
                }, 600)

            }


            return {
                data,
                launchApp,
                isTouchDevice
            }
        }
    }

</script>

<style scoped lang="scss">

    .version-download-control {
        width:100%;
        display:flex;
        flex-flow:row;

        a {
             margin:5px;
             &:first-child {
                 margin-left:0;
             }

            &:last-child {
                margin-right:0;
            }

            img {
                width:100%;
            }
        }
    }


</style>